import { LoadState } from "../../constants/enums";

export interface IStatusState {
  statusList: {
    list: IStatus[];
    loading: LoadState;
    totalRecords: number;
    error: string | null;
  };
  masterStatusList: {
    list: IMasterStatus[];
    loading: LoadState;
    totalRecords: number;
    error: string | null;
  };
  status: {
    data: IStatus;
    loading: LoadState;
    error: string | null;
  };
  masterStatus: {
    data: IMasterStatus;
    loading: LoadState;
    error: string | null;
  };
}

export interface IStatus {
  status_uuid: string;
  name: string | null;
  actual_flow: string | null;
  status: "ACTIVE" | "INACTIVE";
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  company_outlet_uuid: string;
  company_outlet_name: string;
}

export interface IMasterStatus {
  master_status_uuid: string | null;
  status_uuid: string | null;
  drive_status_uuid: string | null;
  name: string;
  actual_status: string;
  description: string;
  status: "ACTIVE" | "INACTIVE";
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
}

export const initialStatus: IStatus = {
  status_uuid: "",
  name: null,
  actual_flow: null,
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  company_outlet_uuid: "",
  company_outlet_name: "",
};

export const initialMasterStatus: IMasterStatus = {
  master_status_uuid: null,
  status_uuid: null,
  drive_status_uuid: null,
  name: "ONGOING",
  actual_status: "ONGOING",
  description: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
};

export const initialStatusState: IStatusState = {
  statusList: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  status: {
    data: initialStatus,
    loading: LoadState.NotLoaded,
    error: null,
  },
  masterStatusList: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  masterStatus: {
    data: initialMasterStatus,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
